<section>
  <form class="needs-validation container-style" novalidate [formGroup]="formComponent">
    <div class="row">
      <div class="col-lg-12 col-12">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
              (onChangeNumber)="changeCode($event)"></app-custom-input-number>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-input-text formControlName="name" [labelText]="'Nombre'"
              [required]="true"></app-custom-input-text>
          </div>
          <div class="col-lg-12 col-md-12 col-12 d-flex justify-content-between mt-3">
            <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'"
              (onClick)="createNewRegister()">
            </app-custom-button>

            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
              (onClick)="send()">
            </app-custom-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>